import React from 'react';

function Card({ title, image, description, tags = [] }) {
  return (
    <div className="transform transition-transform duration-300 ease-in-out hover:scale-105 hover:rotate-1 bg-gray-800 rounded-lg shadow-strong hover:shadow-xl">
      <img src={image} alt={title} className="h-60 w-full object-cover rounded-t-lg"/>
      <div className="p-4">
        <h3 className="text-lg font-bold mt-2 text-white">{title}</h3>
        <p className="text-gray-300 mb-3">{description}</p>
        
        {/* Tags section */}
        {tags && tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-3">
            {tags.map((tag, index) => (
              <span
                key={index}
                className={`px-2 py-1 rounded-full text-xs font-medium text-white ${tag.color} hover:opacity-80 transition-opacity duration-200`}
              >
                {tag.name}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Card;  